import { ChangeDetectionStrategy, Component, DestroyRef, OnInit } from '@angular/core';
import { UiKitModule } from '../../../../../../shared/ui-kit/ui-kit.module';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { select, Store } from '@ngrx/store';
import { YoutubeSelectors } from '@states/youtube/youtube.selector-types';
import { AppState } from '../../../../../../store/app.state';
import { AsyncPipe, NgIf } from '@angular/common';
import { YoutubeActions } from '@states/youtube/youtube.action-types';
import { YoutubeEffects } from '@effects/youtube.effects';
import { ofType } from '@ngrx/effects';
import { TranslatePipe } from '@ngx-translate/core';
import { EnableEscCloseDirective } from '../../../../../../shared/directives/enable-esc-close.directive';
import { UiButtonComponent } from '@ui';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-add-youtube-modal',
  standalone: true,
  imports: [
    UiKitModule,
    ReactiveFormsModule,
    NgIf,
    AsyncPipe,
    MatDialogModule,
    TranslatePipe,
    UiButtonComponent,
  ],
  templateUrl: './add-youtube-modal.component.html',
  styleUrl: './add-youtube-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  hostDirectives: [EnableEscCloseDirective],
})
export class AddYoutubeModalComponent implements OnInit {
  public selectIsSaving$: Observable<boolean> = this.store$.pipe(select(YoutubeSelectors.selectIsSaving));

  public addYoutubeForm: FormGroup = this.fb.group({
    name: ['', Validators.required],
    url: ['', Validators.required],
  });

  constructor(
    private dialogRef: MatDialogRef<AddYoutubeModalComponent>,
    private fb: FormBuilder,
    private store$: Store<AppState>,
    private youtubeEffects: YoutubeEffects,
    private destroyRef: DestroyRef,
  ) {}

  public ngOnInit() {
    this.youtubeEffects.serverRequestCreateYoutube$
      .pipe(takeUntilDestroyed(this.destroyRef), ofType(YoutubeActions.serverRequestCreateYoutubeSuccess))
      .subscribe((res) => {
        this.dialogRef.close();
      });
  }

  public close() {
    this.dialogRef.close();
  }

  public add() {
    this.store$.dispatch(
      YoutubeActions.startCreateYoutube({ isSave: false, form: this.addYoutubeForm.value }),
    );
  }
}
